import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { Icon } from './Icon';
import { IconProps } from './types/IconProps';

export const DriveFolderUploadOutlinedIcon = (props: IconProps): ReactNode => (
  <Icon {...props} testId={locator.components.icon.driveFolderUploadOutlined}>
    <path d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m0 12H4V6h5.17l2 2H20zM9.41 14.42 11 12.84V17h2v-4.16l1.59 1.59L16 13.01 12.01 9 8 13.01z" />
  </Icon>
);
